<template>
    <div class="list-content content">
        <div>
            <div class="list" v-if="list.length">
                <MyWaterfall :list="list" :type="type" :busy="busy" @load="loadMore"></MyWaterfall>
            </div>
            <no-result v-if="!busy&&!list.length" :src="src"
                       :text="getNoResultText()"></no-result>
        </div>
        <loading v-show="busy" style="margin-top:60px;padding-bottom:80px;"></loading>
    </div>
</template>
<script>
    import noResult from '../pages/products/noResult.vue'
    import loading from './loading.vue'
    import MyWaterfall from './my-waterfall.vue'
    import search_no_result from '../../images/cut/search_no_result.png'

    export default{
        data(){
            return {
                src:search_no_result
            }
        },
        props:{
            localImgSearch:{
                type:[String,Number],
                default:''
            },
            keyword:{
                type:String,
                default:''
            },
            busy:{
                type:Boolean,
                required:true
            },
            list:{
                type:Array
            },
            type:{
                type:String,
                default:'product'
            }
        },
        components:{
            noResult,
            loading,
            MyWaterfall
        },
        methods:{
            getNoResultText(){
                if(this.localImgSearch){
                    return '该图片搜索下暂无结果,试试其他图片'
                }
                if(this.keyword){
                    return `没有找到 "${this.keyword}" 相关的内容,试试输入其他关键词`
                }
                return '该筛选条件下无结果,试试其他筛选条件'
            },
            loadMore(){
                this.$emit('load');
            }
        }
    }
</script>
<style scoped type="text/scss" lang="scss">
    .list-content {
        padding-top: 20px;
        margin-bottom: 50px;
    }
</style>
